<template>
  <v-img :src="imageUrl" width="100%" height="auto" :alt="imageAlt" />
</template>

<script setup lang="ts">
import { ref, onMounted, computed } from 'vue'
import { getCDNUrl, getImageAsync, getTrimColorizedImage } from '@/utils'

const cdnUrl = getCDNUrl()
const noVehicleImage = `${cdnUrl}/lightning-model-page/cx/no-vehicle-image.png`

const props = defineProps<{
  trim: any
  size: string
}>()

const imageUrl = ref<string>('')
const imageAlt = computed(() => {
  return `${props.trim.year} ${props.trim.make} ${props.trim.model} ${props.trim.trim}`
})

onMounted(async () => {
  const trimData = props.trim

  const styleId = trimData.styleId
  const make = trimData.make
  const model = trimData.model
  const trim = trimData.trim
  const color = trimData.images?.colorized?.[0]?.colorValue ?? ''
  const size = props.size

  const image = await getImageAsync(styleId, make, model, trim, color, size)

  if (image != null) {
    imageUrl.value = image
  } else {
    imageUrl.value =
      getTrimColorizedImage(props.trim, color) ?? trimData.img ?? noVehicleImage
  }
})
</script>
